import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import SectionAdd from "@/components/InterventionTemplate/SectionAdd";
import SectionEdit from "@/components/InterventionTemplate/SectionEdit";
import { useSidePanel } from "@/modules/side-panel";

const SectionEditor = ({ template, onRemoveSection, onDuplicateSection }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { openSidePanel } = useSidePanel();

  const query = new URLSearchParams(location?.search);

  const layoutIndex = query.has("layout_index")
    ? parseInt(query.get("layout_index"))
    : template.layout_index;

  const isEditable = template?.is_editable ?? false;
  const isRootTemplate = !layoutIndex || layoutIndex === template.layout_index;

  const onAddSection = () => {
    openSidePanel({
      title: isRootTemplate
        ? t("interventionTemplate:createSection")
        : t("interventionTemplate:createSubSection"),
      component: <SectionAdd template={template} layoutIndex={layoutIndex} />,
    });
  };

  const onEditSection = () => {
    openSidePanel({
      title: isRootTemplate
        ? t("interventionTemplate:editSection")
        : t("interventionTemplate:editSubSection"),
      component: (
        <SectionEdit
          template={template}
          layoutIndex={layoutIndex ?? template.layout_index}
        />
      ),
    });
  };

  return (
    <>
      {isEditable && !isRootTemplate && (
        <Button
          aria-label="editSection"
          type="dashed"
          icon={<EditOutlined />}
          onClick={onEditSection}
        />
      )}
      {isEditable && (
        <Button
          aria-label="addSection"
          type="dashed"
          icon={<PlusOutlined />}
          onClick={onAddSection}
        />
      )}
      {isEditable && !isRootTemplate && (
        <>
          <Button
            aria-label="duplicateSection"
            type="dashed"
            icon={<CopyOutlined />}
            onClick={() => onDuplicateSection(layoutIndex)}
          />

          <Button
            aria-label="removeSection"
            type="dashed"
            icon={<DeleteOutlined />}
            onClick={() => onRemoveSection(layoutIndex)}
          />
        </>
      )}
    </>
  );
};

export default SectionEditor;
